import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import { alarmRoutes } from './alarm'
import { companyRoutes } from './company'
import { lineRoutes } from './line'
import { machineRoutes } from './machine'
import { sensorRoutes } from './sensor'
import { warningRoutes } from './warning'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  companyRoutes,
  sensorRoutes,
  machineRoutes,
  lineRoutes,
  alarmRoutes,
  warningRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
